fx.ns("creators", class ChronologicalCreator {

    constructor(data)
	{
		this.data = data;
    }

    placePhotos(photos)
	{
        this.data.book.event("placing-photos");
		// sort chronologically
		photos.sort(function(a, b) { return (a.date_taken_unix - b.date_taken_unix);});

		this.data.book.themeid = 0;

		this.data.book.cover.removeAllContent();

		let photo = photos.shift();

		let frontCoverLayout = fx.service("LayoutsGenerator").getLayouts([photo])[0];
        this.data.book.cover.applyLayout( frontCoverLayout,  this.data.book.pageWidth + this.data.book.sliceWidth, this.data.book.pageHeight, this.data.book.sliceWidth, "right");
       
        let photoComponent = this.data.book.cover.getComponents("right", this.data.book.pageWidth, 0).filter(component => component.component_type == "photo")[0];
		photoComponent.update({content : photo.id, width_inner : 0});
        
		let pageIndex = 0, side = "right";
        for (let i = 0; i < photos.length; i++)
        {
            let currentPage = this.data.book.innerPages.getItemAt(pageIndex);
            let photo = photos.getItemAt(i);

            let layout = fx.service("LayoutsGenerator").getLayouts([photo])[0];
     
            currentPage.applyLayout(layout, this.data.book.pageWidth, this.data.book.pageHeight,0, side);
            
            let photoComponent = currentPage.getComponents(side, this.data.book.pageWidth, 0).filter(component => component.component_type == "photo")[0];
            
            photoComponent.update({content : photo.id, effectName : photo.needBrightness ? 2 : 1, width_inner : 0});
         
            if (side == "right")
            {
                side = "left";
                pageIndex++;
            }
            else
                side = "right";

            if (pageIndex == this.data.book.innerPages.length -1 )
            {
                if (i >= photos.length - 2) // last page & last group of pictures, we don't add a page
                    continue;

                let page = this.data.book.addPage(this.data.book.innerPages.getItemAt(pageIndex), "right", true, true, this.data.layouts);
                page.removeAllContent();
            }
        }
		
		this.photoPlacedAlready = true;
		
        this.data.book.event("placing-photos-finished", null, 250);
	}

});